import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { setFullViewportWidthStyles } from "shared/lib/styles";

import { GameType } from "scmp-app/components/games/types";

const getGameBackgroundColor = (gameType: GameType) => {
  switch (gameType) {
    case GameType.Cryptic:
      return "#1e2836";
    case GameType.MiniSudoku:
      return "#1C3017";
    case GameType.Quick:
      return "#ffffff";
    case GameType.WordSearch:
      return "#FF7728";
  }
};

export const globalCss = (gameType: GameType) => css`
  #__next {
    background-color: ${getGameBackgroundColor(gameType)};
  }
`;

interface IframeContainerProps {
  $isLoading: boolean;
}

export const IframeContainer = styled.div<IframeContainerProps>`
  ${setFullViewportWidthStyles()}
  ${props =>
    props.$isLoading
      ? css`
          block-size: calc(100vh - 166px);
          ${props.theme.breakpoints.up("tablet")} {
            block-size: calc(100vh - 179px);
          }
          ${props.theme.breakpoints.up("desktop")} {
            block-size: calc(100vh - 349px);
          }
        `
      : css`
          block-size: auto;
        `}
  position: relative;

  overflow: hidden;
`;

export const IframeWrapper = styled.div``;
